import React, { Component } from 'react';
import './ExperienceCard.css';
import { Fade } from "react-reveal";

class ExperienceCard extends Component {
  render() {
    const experience = this.props.experience;
    const index = this.props.index;
    const totalCards = this.props.totalCards;
    return (
      <div className="experience-list-item" style={{ marginTop: (index === 0 ? 24 : 34) }}>
        <Fade left duration={2000} distance="40px">
          <div className="experience-card-logo-div">
            <img
              className="experience-card-logo"
              src={require(`../../assests/images/${experience["logo_path"]}`)}
              alt=""
            />
          </div>
        </Fade>
        <div className="experience-card-stepper">
          <div className="experience-card-dot" />
          {
            index !== (totalCards - 1) &&
            <div className="experience-card-line" />
          }
        </div>
        <Fade right duration={2000} distance="40px">
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <div className="arrow-left"></div>
            <div className="experience-card">
              <div className="experience-card-header-row">
                <div>
                  <h3 className="experience-card-title">{experience["title"]}</h3>
                  <p className="experience-card-company">
                    <a href={experience["company_url"]} target="_blank" rel="noopener noreferrer">
                      {experience["company"]}
                    </a>
                  </p>
                </div>
                <div>
                  <div className="experience-card-heading-right">
                    <p className="experience-card-duration">{experience["duration"]}</p>
                    <p className="experience-card-location">{experience["location"]}</p>
                  </div>

                </div>
              </div>
              <div className="experience-card-description-text">
                <div
                  className="repo-description"
                />
                {experience["description"]}
              </div>

            </div>

          </div>
        </Fade>
      </div>

    );
  }
}

export default ExperienceCard;
